'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (node) {
	return {
		type: 'MESSAGE_FORM',
		name: 'Message Form',
		allowedSections: ['footer', 'header', 'main'],
		disallowedChildren: [],
		category: 'Form',
		styleClasses: {},
		props: [{
			label: 'Notifcation Template',
			name: 'template',
			inputType: 'text',
			default: ''
		}, {
			label: 'Send to helpdesk',
			name: 'helpdesk',
			inputType: 'checkbox',
			default: false
		}, node && node.props.helpdesk && {
			label: 'Helpdesk tag IDs',
			name: 'helpdeskTagId',
			inputType: 'text',
			default: ''
		}, {
			label: 'Reply to field',
			name: 'replyToField',
			inputType: 'text',
			default: ''
		}, {
			label: 'Submit button name',
			name: 'submitName',
			inputType: 'text',
			default: 'Submit'
		}, {
			label: 'Use reCAPTCHA',
			name: 'useRecaptcha',
			inputType: 'checkbox',
			default: true
		}].filter(Boolean),
		hiddenProps: [{
			label: 'Feedback Messages',
			props: [{
				label: 'Success feedback message',
				name: 'feedbackMessageSuccess',
				inputType: 'html',
				default: ''
			}, {
				label: 'Error feedback message',
				name: 'feedbackMessageError',
				inputType: 'html',
				default: ''
			}]
		}]
	};
};